import { render, staticRenderFns } from "./ShopsEditing.vue?vue&type=template&id=1177ca64"
import script from "./ShopsEditing.vue?vue&type=script&lang=js"
export * from "./ShopsEditing.vue?vue&type=script&lang=js"
import style0 from "./ShopsEditing.vue?vue&type=style&index=0&id=1177ca64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports